export default __webpack_public_path__ + "static/home-mobile-1-f9533568facf89714aca7b7882344d54.png";